import { Guid } from 'src/application/store/model/guid';

import { getValidMainItemsSelector } from './selectors';
import { isMenuItem, MainItem } from '@ael/core-api';
import { createSelector } from 'reselect';

export const getValidPrecedentNonMenuItems = (validItems: MainItem[]) => (itemId: Guid) => {
  const itemsWithoutMenuItems = validItems.filter((item) => !isMenuItem(item) || item.id === itemId);
  const currentItemIndex = itemsWithoutMenuItems.findIndex((validMenuItem) => validMenuItem.id === itemId);
  return itemsWithoutMenuItems.slice(0, currentItemIndex);
};

export const getValidPrecedentNonMenuItemSelector = createSelector(
  getValidMainItemsSelector,
  getValidPrecedentNonMenuItems
);
